import { render, staticRenderFns } from "./CommodityReview.vue?vue&type=template&id=ed91c892&scoped=true&"
import script from "./CommodityReview.vue?vue&type=script&lang=js&"
export * from "./CommodityReview.vue?vue&type=script&lang=js&"
import style0 from "./CommodityReview.vue?vue&type=style&index=0&id=ed91c892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed91c892",
  null
  
)

export default component.exports